<template>
  <div class="app flex-row auth-page">
    <div class="container-fluid">

      <b-row>
        <b-col md="7" class="auth-hero-column d-none d-md-block">
          <BrandLoginHero />
        </b-col>

        <b-col md="5" class="auth-panel-column">
          <main class="auth-panel">
            <div class="auth-brand">
            <BrandLoginHero compact />
            </div>

            <b-card no-body class="auth-card">
              <b-card-body class="auth-card-body">
              <div v-if="hasCustomerBrand" class="auth-customer-brand">
                <span class="auth-customer-brand__label">Espacio de trabajo</span>
                <CustomerBrandLogo variant="full" context="auth" :alt="customerName" />
              </div>
              <b-form class="auth-form" @submit.prevent="register">
                <div class="auth-heading">
                  <div class="auth-panel-header">
                    <AppIcon name="person_add" />
                    <span class="auth-panel-title">Crear usuario</span>
                  </div>
                  <p>Completá tus datos para solicitar una cuenta en la plataforma.</p>
                </div>

                <b-form-group label="Nombre" class="auth-field">
                  <b-input-group class="auth-input-group">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <AppIcon name="person" />
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Tu nombre completo" autocomplete="name" v-model="form.name"/>
                  </b-input-group>
                </b-form-group>

                <b-form-group label="Correo electrónico" class="auth-field">
                  <b-input-group class="auth-input-group">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <AppIcon name="mail" />
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="email" class="form-control" placeholder="tu@email.com" autocomplete="email" v-model="form.email"/>
                  </b-input-group>
                </b-form-group>

                <b-form-group label="Contraseña" class="auth-field">
                  <b-input-group class="auth-input-group">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <AppIcon name="lock" />
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Al menos 6 caracteres" autocomplete="new-password" v-model="form.password"/>
                  </b-input-group>
                </b-form-group>

                <b-form-group label="Confirmar contraseña" class="auth-field">
                  <b-input-group class="auth-input-group">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <AppIcon name="check_circle" />
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Repetí tu contraseña" autocomplete="new-password" v-model="form.confirmPassword"/>
                  </b-input-group>
                </b-form-group>

                <b-button type="submit" variant="primary" class="auth-submit primary-background">
                  <AppIcon name="person_add" class="mr-2" /> REGISTRAR
                </b-button>

                <div class="auth-actions">
                  <b-button variant="link" class="auth-link" @click="ir('login')">
                    <AppIcon name="arrow_back" /> Ya tengo una cuenta
                  </b-button>
                </div>

              </b-form>
            </b-card-body>
          </b-card>
          </main>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import serviceAPI from './services'
  import Helper from '@/handler/helper'
  import Param from '@/config/parameters'
  import {EventBus} from '@/handler/event-bus'
  import BrandLoginHero from '@/components/branding/BrandLoginHero'
  import Branding from '@/components/branding/branding'
  import CustomerBrandLogo from '@/components/branding/CustomerBrandLogo'

  export default {
    components: {
      BrandLoginHero,
      CustomerBrandLogo,
    },
    data () {
      return {
        brandingVersion: 0,
        form: {
          name: '',
          email: '',
          password: '',
          confirmPassword: ''
        },           
      }
    },
    computed: {
      customerName() {
        const session = Session.getSession()
        return session && session.settings
          ? session.settings.proyect_name || 'Empresa'
          : 'Empresa'
      },
      hasCustomerBrand() {
        this.brandingVersion
        const session = Session.getSession()
        const branding = Branding.resolve(session && session.settings)
        return (branding.logoCustomized && branding.logo) ||
               (branding.iconCustomized && branding.icon)
      },
    },
    created() {
      EventBus.$on('Settings:settings', this.refreshBranding)
    },
    beforeDestroy() {
      EventBus.$off('Settings:settings', this.refreshBranding)
    },
    mounted() {
      this.setupParameters()
    },
    methods: {
      refreshBranding() {
        this.brandingVersion++
      },
      setupParameters () {
        if(!Helper.hasParametersAccess(Param.P1)) {
          this.$router.push({ name: 'Error403' })
        }
      },            
      ir(path) {
        if(path == 'login') {
          this.$router.push({ name: 'Login' })
        }
      },
      register () {
        if(this.form.password.length < 6) {
          this.$awn.alert("La contraseña debe tener al menos 6 caracteres")
          return
        }

        if(this.form.password !== this.form.confirmPassword) {
          this.$awn.alert("Las contraseñas no coinciden")
          return
        }

        let loader = this.$loading.show();

        var result = serviceAPI.register(this.form)

        result.then((response) => {
          var data = response.data

          loader.hide()
          
          if(data){
            this.$awn.success("Se creó su usuario con éxito");

            this.ir('login')
          } else {
            loader.hide()
            this.$awn.alert("Ups!! Ocurrió un error! Intente más tarde!");
          }
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      }
    },
  }
</script>

<style src="./auth.css"></style>
